import api from '@/services/api';
import { PaginatedResponse } from '@/types/common';
import { CurationDateRange, CurationPostsParams, RawCurationPost } from '@/types/curation';

export const curationService = {
  async getPosts(params: CurationPostsParams): Promise<PaginatedResponse<RawCurationPost>> {
    const queryParams = new URLSearchParams()
    const offset = params.offset ?? 0
    const limit = params.limit ?? 10
    queryParams.append('offset', String(offset))
    queryParams.append('limit', String(limit))
    if (params.date_range) queryParams.append('date_range', params.date_range)
    if (params.q) queryParams.append('q', params.q)
    if (params.territories) params.territories.split(',').filter(Boolean).forEach(v => queryParams.append('territories', v))
    if (params.contexts) params.contexts.split(',').filter(Boolean).forEach(v => queryParams.append('contexts', v))
    if (params.topics) params.topics.split(',').filter(Boolean).forEach(v => queryParams.append('topics', v))
    if (params.sources) params.sources.split(',').filter(Boolean).forEach(v => queryParams.append('sources', v))
    if (params.partners) params.partners.split(',').filter(Boolean).forEach(v => queryParams.append('partners', v))
    if (typeof params.favorited === 'boolean') queryParams.append('favorited', String(params.favorited))
    if (params.created_by) queryParams.append('created_by', params.created_by)
    const url = `/curation/posts?${queryParams.toString()}`
    const response = await api.get<PaginatedResponse<RawCurationPost>>(url)
    return response.data
  },
  async favorite(postId: string): Promise<void> {
    await api.post(`/curation/posts/${postId}/favorite`)
  },
  async getTrending(): Promise<Array<{ context: { id: string; name: string }; postCount: number }>> {
    const response = await api.get<Array<{ context: { id: string; name: string }; postCount: number }>>('/curation/trending')
    return response.data
  }
}


